import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
import { FaSignInAlt, FaBars, FaTimes } from "react-icons/fa";

const Navbar = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isPolicyDropdownOpen, setIsPolicyDropdownOpen] = useState(false);
  const policyRef = useRef(null);
  const dropdownRef = useRef(null);
  const hoverTimeoutRef = useRef(null);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (isPolicyDropdownOpen) {
      setIsPolicyDropdownOpen(false);
    }
  };
  const closeMobileMenu = () => {
  setIsMobileMenuOpen(false);
  setIsPolicyDropdownOpen(false);
};

  // For mobile: toggle dropdown on click
  const togglePolicyDropdown = () => {
    if (window.innerWidth <= 1024) {
      setIsPolicyDropdownOpen(!isPolicyDropdownOpen);
    }
  };

  // For desktop: open on hover with delay for closing
  const handlePolicyHover = (open) => {
    if (window.innerWidth > 1024 ) {
      clearTimeout(hoverTimeoutRef.current);
      
      if (open) {
        setIsPolicyDropdownOpen(true);
      } else {
        // Add small delay before closing to allow moving to dropdown
        hoverTimeoutRef.current = setTimeout(() => {
          setIsPolicyDropdownOpen(false);
        }, 200);
      }
    }
  };

  // Keep dropdown open when hovering over it
  const handleDropdownHover = () => {
    if (window.innerWidth > 1024 && isPolicyDropdownOpen) {
      clearTimeout(hoverTimeoutRef.current);
      setIsPolicyDropdownOpen(true);
    }
  };

  // Close dropdown when leaving it
  const handleDropdownLeave = () => {
    if (window.innerWidth > 1024 && isPolicyDropdownOpen) {
      hoverTimeoutRef.current = setTimeout(() => {
        setIsPolicyDropdownOpen(false);
      }, 200);
    }
  };

  // Keep the existing useEffect for outside click detection
  useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      policyRef.current &&
      !policyRef.current.contains(event.target)
    ) {
      setIsPolicyDropdownOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);


  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="navbar-left">
          <img
            src="https://res.cloudinary.com/dy8shu8ss/image/upload/v1744709155/image-removebg-preview_sqzgei.png"
            alt="Logo"
            className="logo"
          />
          <span className="company-name">Vero Disruptors</span>
        </div>
        <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? <FaTimes className="icon" /> : <FaBars className="icon" />}
        </div>
        <div className={`navbar-middle ${isMobileMenuOpen ? "active" : ""}`}>
          <Link to="/" className={location.pathname === "/" ? "active" : ""} onClick={toggleMobileMenu}>
            Home
          </Link>
          <Link to="/products" className={location.pathname === "/products" ? "active" : ""} onClick={toggleMobileMenu}>
            Products
          </Link>
          <Link to="/services" className={location.pathname === "/services" ? "active" : ""} onClick={toggleMobileMenu}>
            Services
          </Link>
          <Link to="/careers" className={location.pathname === "/careers" ? "active" : ""} onClick={toggleMobileMenu}>
            Careers
          </Link>
          <Link to="/contactus" className={location.pathname === "/contactus" ? "active" : ""} onClick={toggleMobileMenu}>
            Contact Us
          </Link>
          
          {/* Refund Policy with hover on desktop, click on mobile */}
          <div 
            className="policy-link-container"
            ref={policyRef}
            
          >
            <div 
              className="policy-link"
              onClick={togglePolicyDropdown}
              onMouseEnter={() => handlePolicyHover(true)}
            onMouseLeave={() => handlePolicyHover(false)}
            >
              Refund Policy <span className="caret-down"></span>
            </div>
            
            {/* Dropdown - now as a sibling of policy-link */}
            <div 
              className="policy-dropdown"
              ref={dropdownRef}
              onMouseEnter={handleDropdownHover}
  onMouseLeave={handleDropdownLeave}
            >
              <div className={`policy-dropdown-content ${isPolicyDropdownOpen ? "show" : ""}`}>
                <Link to="/about" onClick={closeMobileMenu}>
  About Us
</Link>

<Link to="/privacy" onClick={closeMobileMenu}>
  Privacy Policy
</Link>

<Link to="/terms" onClick={closeMobileMenu}>
  Terms and Conditions
</Link>

<Link to="/refund" onClick={closeMobileMenu}>
  Refund and Cancellation Policy
</Link>

<Link to="/contactus" onClick={closeMobileMenu}>
  Contact Us
</Link>

              </div>
            </div>
          </div>
          
          <Link to="/login" className="login-button" onClick={toggleMobileMenu}>
            <FaSignInAlt className="icon" /> Login
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;